import { contact } from '../../portfolio'
import './Contact.css'

const Contact = () => {
  if (!contact.email) return null

  return (
    <section className='section contact reveal center' id='contact'>
      <h2 className='section__title'>Contact</h2>
      <div className='center'>
      <a href={`mailto:${contact.email}`}>
        <span type='button' className='btn btn--outline'>
          Email me
        </span>
      </a>
      <a href="https://wa.link/885hpq" target="_blank"  rel="noreferrer">
        <span type='button' className='btn btn--outline'>
          Whatsapp me
        </span>
        </a>
        </div>
    </section>
  )
}

export default Contact
